<template>
  <span
    v-if="targetStatus"
  >
    <q-icon
      v-if="showArrow"
      name="arrow_forward"
      size="xxs"
      color="grey-6"
    />
    <transition
      appear
      :enter-active-class="transition"
    >
      <q-chip
        :size="size"
        :text-color="getTextColor(getTargetProperty(targetStatus, 'color', ''))"
        :color="getTargetProperty(targetStatus, 'color', '')"
        :style="{ backgroundColor: getTargetProperty(targetStatus, 'color', '') }"
        :icon="getTargetProperty(targetStatus, 'icon', 'help')"
        :icon-remove="editIcon"
        :removable="editable"

        :class="{
          'chip-no-label': hideLabel,
          'q-mx-none': noMargin,
        }"
        class="q-my-none"
        @remove="onEdit"
      >
        <span
          v-if="!hideLabel"
          :class="{'q-pr-sm':editable}"
        >
          {{ getTargetProperty(targetStatus, 'label', 'unknown') }}
        </span>
        <q-tooltip
          v-else
        >
          {{ getTargetProperty(targetStatus, 'label', 'unknown') }}
        </q-tooltip>
      </q-chip>
    </transition>
  </span>
</template>
<script>
import { targetStatuses } from 'boot/globals';
import { get, isEmpty } from 'lodash';
import { getTextColor } from 'src/utils/TargetUtils';

export default {
  name: 'StatusChip',

  props: {
    targetStatus: {
      type: String,
      default: null,
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
    transition: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
    statuses: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  emits: ['edit'],

  computed: {
    editIcon() {
      if (!this.editable) {
        return null;
      }
      return 'edit';
    },
  },

  methods: {
    getTextColor,

    onEdit() {
      this.$emit('edit', this.targetStatus);
    }, // onEdit()

    getTargetProperty(targetStatus, property, defaultValue = '') {
      if (!isEmpty(this.statuses)) {
        return get(this.statuses, [targetStatus, property], defaultValue);
      }
      return get(targetStatuses, [targetStatus, property], defaultValue);
    }, // getTargetProperty()

  },
};
</script>
